module.exports = __webpack_public_path__ + "img/Agencia-Latacunga.08abff3d.jpg";